import { InitialState } from '../state';
import { AppReducer } from './app-reducer';

export const trendExportReducer: AppReducer<'TrendExport'> = (
    state = InitialState.TrendExport,
    action
): typeof state => {
    switch (action.type) {
        case 'TrendExport/Load/Started':
            return {
                loading: true,
                success: false,
                url: '',
            };
        case 'TrendExport/Load/Succeeded':
            return {
                loading: false,
                success: true,
                url: action.payload.url,
            };
        case 'TrendExport/Load/Failed':
        case 'TrendExport/Load/Unmounted':
            return {
                loading: false,
                success: false,
                url: '',
            };
        default:
            return state;
    }
};
